<template>
    <div :class="classes" :style="styles">
        <slot name="upload-button"><button class="btn--plain is--primary-icon is--center is--large"><i class="icon-upload2"></i></button></slot>
    </div>
</template>

<script>
    import EventBus from '../event-bus';
    import MobileDetect from 'mobile-detect';
    import NProgress from 'nprogress';
    import plupload from 'plupload';
    import Compress from 'compress.js';
    import { generateRandomID } from '../utilities';
    import { converting } from "../mixins/convertingMixin";
    import { gtag_event } from "../gtag";
    import Tiff from "tiff.js";
    import EXIF from "exif-js";
    import loadImage from "blueimp-load-image";

    export default {
        data() {
            return {
                compressor: new Compress(),
                uploader: false,
                files: [],
                errors: [],
                chunkSize: '1mb',
                maxFileCount: 1,
                minFileSize: '100kb',
                maxFileSize: '25mb',
                mimeTypes: [
                    { 'title': 'Image files', 'extensions': 'jpg,jpeg,png,tif,tiff' }
                ],
                uploadFinished: false,
                interval: false,
                countdown: 0,
            };
        },

        props: {
            eventPrefix: {
                type: String,
                default() {
                    return '';
                },
            },

            classes: {
                type: Object,
                default() {
                    return {};
                }
            },

            styles: {
                type: Object,
                default() {
                    return {};
                }
            },

            timeout: {
                type: Number,
                default: 5
            },

            modalWidth: {
                default: () => {
                    return (new MobileDetect(window.navigator.userAgent)).mobile() ? 300 : 600;
                }
            },

            modalHeight: {
                default: () => {
                    return 'auto';
                }
            },
        },

        methods: {
            convertErrorToMessage(error) {
                let messageKey;

                switch (error.code) {
                    case -600:
                        let minSize = plupload.parseSize(this.minFileSize);

                        if (error.file.origSize < minSize) {
                            messageKey = 'uploader.minSizeViolation';
                        } else {
                            messageKey = 'uploader.maxSizeViolation';
                        }
                        break;

                    case -601:
                        messageKey = 'uploader.fileTypeViolation';
                        break;

                    default:
                        messageKey = 'uploader.unknownError';
                }

                return this._i18n.t(messageKey);
            },

            add(file) {
                this.$emit('added', file);
            },

            complete(file) {
                this.$emit('completed', file);
            },

            reset() {
                this.files          = [];
                this.errors         = [];
                this.uploadFinished = false;
                window.clearInterval(this.interval);
                this.countdown      = 0;
            },

            close() {
                if (this.uploadFinished) {
                    this.$emit('finished');
                }

                this.reset();
            },

            loadFileIntoCanvas(file) {
                return new Promise((resolve, reject) => {
                    switch (file.type) {
                        case "image/tiff":
                            let reader = new FileReader();

                            reader.onload = ev => {
                                Tiff.initialize({TOTAL_MEMORY: 30000000});  // 30MB

                                let tiff   = new Tiff({ buffer: ev.target.result }),
                                    canvas = tiff.toCanvas();

                                resolve(canvas);
                            };

                            reader.readAsArrayBuffer(file.getNative());
                            break;

                        default:
                            loadImage(
                                this.createUrlToFile(file.getNative()),
                                function (img) {
                                    resolve(img);
                                },
                                {
                                    maxWidth: 2000,
                                    maxHeight:2000,
                                    minWidth: 100,
                                    minHeight: 100,
                                    canvas: true
                                }
                            );
/*
                            let image = new Image();

                            image.onload = () => {
                                let canvas  = document.createElement("canvas"),
                                    context = canvas.getContext("2d");
                                EXIF.getData(image, function() {
                                    let width       = image.width,
                                        height      = image.height,
                                        orientation = EXIF.getTag(this, "Orientation"),
                                        max         = 2000;

                                    if (Math.pow(max, 2) < width * height) {
                                        let factor = 1;

                                        if (width > height) {
                                            factor = max / width;
                                        } else {
                                            factor = max / height;
                                        }

                                        width  *= factor;
                                        height *= factor;
                                    }

                                    canvas.width  = width;
                                    canvas.height = height;

                                    context.save();

                                    switch (orientation) {
                                        case 3:
                                            context.translate(width, height);
                                            context.rotate(180 * Math.PI / 180);
                                            break;

                                        case 6:
                                            if (canvas.width >= canvas.height) {
                                                // noinspection JSSuspiciousNameCombination
                                                canvas.width = height;

                                                // noinspection JSSuspiciousNameCombination
                                                canvas.height = width;

                                                context.rotate(90 * Math.PI / 180);
                                                context.translate(0, -height);
                                                }
                                            break;

                                        case 8:
                                            if (canvas.width >= canvas.height) {
                                                // noinspection JSSuspiciousNameCombination
                                                canvas.width = height;

                                                // noinspection JSSuspiciousNameCombination
                                                canvas.height = width;

                                                // noinspection JSSuspiciousNameCombination
                                                context.translate(0, width);
                                                context.rotate(-90 * Math.PI / 180);
                                            }
                                            break;
                                    }

                                    context.drawImage(image, 0, 0, width, height);
                                    context.restore();

                                    resolve(canvas);
                                });
                            };

                            image.src = this.createUrlToFile(file.getNative());
                            break;

 */
                    }
                });
            },

            getImageDimensions(imageUrl) {
                let image = new Image();

                return new Promise((resolve, reject) => {
                    image.onload = () => {
                        resolve({
                            image,
                            insufficientQuality: image.width < 800 || image.height < 800
                        });
                    };

                    // image.onerror = event => {};

                    image.src = imageUrl;
                });
            },
        },

        beforeDestroy() {
            EventBus.$off(this.eventPrefix + '_triggerUploadButton', this.$el.firstChild.click);
        },

        mounted() {
            let vm = this;

            plupload.addFileFilter('min_file_size', function(minSize, file, cb) {
                let undef;

                minSize = plupload.parseSize(minSize);

                // Invalid file size
                if (file.size !== undef && minSize && file.size < minSize) {
                    this.trigger('Error', {
                        code : plupload.FILE_SIZE_ERROR,
                        message : plupload.translate('File size error.'),
                        file : file
                    });
                    cb(false);
                } else {
                    cb(true);
                }
            });

            let isInAppBrowser = (function() {
                let ua = navigator.userAgent || navigator.vendor || window.opera;

                return (
                    (ua.indexOf('FBAN') > -1)
                    || (ua.indexOf('FBAV') > -1)
                );
            })();

            (vm.uploader = new plupload.Uploader({
                browse_button: vm.$el.firstChild,
                runtimes: 'html5',
                url: App.url.upload,
                chunk_size: vm.chunkSize,
                max_file_count: vm.maxFileCount,
                filters: {
                    min_file_size: vm.minFileSize,
                    max_file_size: vm.maxFileSize,
                    mime_types: vm.mimeTypes,
                    prevent_duplicates: true
                },
                init: {
                    PostInit(up) {
                        if (! isInAppBrowser) {
                            return;
                        }

                        let uploads = document.querySelectorAll('input[type="file"]'), i = 0;

                        for (; i < uploads.length; i++) {
                            uploads[i].removeAttribute('accept');
                        }
                    },

                    Browse: function(up) {
                        gtag_event('Button Bildupload');
                    },

                    FilesAdded(up, files) {
                        while (files.length > vm.maxFileCount) {
                            up.removeFile(files.pop());
                        }

                        let length = files.length;
                        vm.files = files;

                        EventBus.$emit("startBrowserPreloading");

                        let filesAdded = () => {
                            if (0 === --length) {
                                vm.$emit('filesAdded', vm.files);
                                EventBus.$emit("finishedBrowserPreloading");
                            }
                        };

                        let config = {
                            size: 1,
                            quality: 1,
                            maxWidth: 640,
                            maxHeight: 480,
                            resize: true
                        };

                        files.forEach((file, idx) => {
                            function proceed(canvas) {
                                canvas.toBlob(blob => {
                                    vm.compressor.compress([ blob ], config).then(results => {
                                        let compressedImage = [
                                            'data:',
                                            results[0].ext,
                                            ';base64,',
                                            results[0].data
                                        ].join("");

                                        file.uuid     = generateRandomID();
                                        file.leonardo = {
                                            fileUrl: compressedImage,
                                            info: false,
                                        };

                                        vm.add(file);
                                    }).then(filesAdded).catch(error => {
                                        filesAdded();
                                    });
                                });

                                up.start();
                            }

                            vm.loadFileIntoCanvas(file).then(canvas => {
                                vm.getImageDimensions(canvas.toDataURL("image/png")).then(info => {
                                    if (info.insufficientQuality) {
                                        vm.$modal.show('dialog', {
                                            title: vm._i18n.t('hint.handles.title'),
                                            text: vm._i18n.t('uploader.insufficientQualityViolation'),
                                            buttons: [
                                                {
                                                    title: vm._i18n.t('uploader.buttonForce'),
                                                    handler: () => {
                                                        proceed(canvas);
                                                        vm.$modal.hide('dialog')
                                                    },
                                                },
                                                {
                                                    title: vm._i18n.t('uploader.buttonTryOtherImages'),
                                                    handler: () => {
                                                        up.removeFile(files.pop());
                                                        vm.$el.firstChild.click();
                                                        vm.$modal.hide('dialog')
                                                    },
                                                }
                                            ]
                                        });

                                        return;
                                    }

                                    proceed(canvas);
                                });
                            });
                        });
                    },

                    FilesRemoved(up, files) {},

                    BeforeUpload(up, file) {
                        file.origName = file.name;
                        file.name     = (new Date).getTime() + '_' + file.name.replace(/([^0-9a-zA-Z\.\-\_]+)/g, '_');
                    },

                    UploadProgress(up, file) {
                        NProgress.set(up.total.percent / 110);
                    },

                    FileUploaded(up, file, xhr) {
                        let response = JSON.parse(xhr.response);

                        file.leonardo = {
                            fileUrl: response.fileUrl,
                            originUrl: response.originUrl,
                            info: response.info
                        };

                        vm.complete(file);
                    },

                    UploadComplete(up, files) {
                        // files.forEach(file => vm.add(file));

                        up.splice();
                        up.refresh();

                        vm.uploadFinished = true;

                        // NProgress.done();
                        // NProgress.remove();

                        if (0 < vm.errors.length) {
                            return;
                        }

                        vm.countdown = vm.timeout;
                        vm.interval  = window.setInterval(() => {
                            vm.countdown --;

                            if (vm.countdown > 0) {
                                return;
                            }

                            vm.close();
                        }, 1000);
                    },

                    Error(up, args) {
                        let text = vm.convertErrorToMessage(args);

                        vm.$modal.show('dialog', {
                            title: vm._i18n.t('hint.handles.title'),
                            text: text,
                            buttons: [
                                {
                                    title: vm._i18n.t('hint.autoWidth.confirm'),
                                    handler: () => {
                                        vm.$modal.hide('dialog')
                                    },
                                }
                            ]
                        });

                        NProgress.remove();
                    }
                }
            })).init();

            EventBus.$on(this.eventPrefix + '_triggerUploadButton', () => this.$el.firstChild.click());
        },

        mixins: [ converting ],
    };
</script>

<style lang="scss" scoped>
    @import "../assets/scss/utilities/colors";
    .btn {
        .icon-upload2 {
            font-size: 1.8rem;
            line-height: 2.4rem;
        }
    }
    .upload-status {
        height: 100%;
        box-sizing: border-box;
        padding: 10px;
        font-size: 13px;
        overflow: auto;
        text-align: center;
        color: $text-color;
        background: #eaeaea;
        border-radius: 6px;

        h3 {
            margin: 10px 0;
        }

        p {
            font-weight: normal;
        }

        li {
            position: relative;
            margin: 6px 0;
            line-height: 1.8rem;

            .is--progress-bar {
                background-color: #21bdff;
                background-image: linear-gradient(to bottom, #21bdff 0%, #009fe3 100%);
                border: 0 none;
                border-radius: 4px;
                width: 0;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
            }

            .is--name, .is--progress-label, .is--message {
                position: absolute;
                top: 0;
                left: 6px;
                color: #fff;
            }

            .is--progress-label, .is--message {
                left: auto;
                right: 6px;
            }
        }

        ul.is--errors li {
            .is--progress-bar {
                background-color: #ff1c26;
                background-image: linear-gradient(to bottom, #ff1c26 0%, #e30135 100%);
                width: 100%;
            }
        }

        .is--countdown {
            margin-top:40px;
            font-weight: normal;
            font-style: italic;
            font-size: smaller;
            margin-top: 20px;
            text-align: right;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue